var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-list-layout',_vm._b({},'dms-list-layout',_vm.layoutProps,false),[_c('dms-table',_vm._g(_vm._b({staticClass:"email-text-table",attrs:{"slot":"content"},slot:"content"},'dms-table',_vm.tableModel,false),_vm.tableListeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }